'use strict';

var FlightProfileChartFilterFactory = function FlightProfileChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightLevelFilterFactory', 'FlightCabinFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FlightProfileChartFilter() {
    DemandFilter.call(this, ['cabin', 'cabin-da', 'cabin-deep', 'cabin-post-departure'], 'flight-profile-chart');
    this.registerFilters(injectedFilters);
  }
  FlightProfileChartFilter.constructor = FlightProfileChartFilter;
  FlightProfileChartFilter.prototype = Object.create(DemandFilter.prototype);
  FlightProfileChartFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  return FlightProfileChartFilter;
};
FlightProfileChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FlightProfileChartFilterFactory;